<video autoPlay muted loop id="myVideo">
  <source
    src="../../assets/videos/main.mp4"
    type="video/mp4"
  />
</video>
